export let fridayAbbreviatedLowercase = "jvr8Ub";
export default {fridayAbbreviatedLowercase};